import http from './../../../core/services/http.service';

export default {
  getCustomLotSequences(params = null, expand = '') {
    return http.get(`/api/v1/custom-lot-sequences/?expand=${expand}`, {params});
  },
  getCustomLotSequence(id, expand = '', params = null) {
    return http.get(`/api/v1/custom-lot-sequences/${id}/?expand=${expand}`, {params});
  },
  removeCustomLotSequence(uuid) {
    return http.delete(`/api/v1/custom-lot-sequences/${uuid}`)
  },
  updateCustomLotSequence(id, data, expand = '') {
    return http.put(`/api/v1/custom-lot-sequences/${id}/?expand=${expand}`, data);
  },
  createCustomLotSequence(data) {
    return http.post('/api/v1/custom-lot-sequences/', data);
  },
};
